import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { CourseStoreModel } from '@examdojo/category';
import { ExamDateStoreModel } from '@examdojo/exam-date';
import { CourseFormDialogComponent } from './course-form-dialog.component';

const COURSE_FORM_DIALOG_ID = 'course-form';

export interface CourseFormDialogInput {
  canSelectExistingSubscriptions?: boolean;
  canQuit?: boolean;
}

export interface CourseFormDialogOutput {
  course: CourseStoreModel;
  examDateId: ExamDateStoreModel['id'];
}

@Injectable({
  providedIn: 'root',
})
export class CourseFormDialogService extends AbstractDialogService<
  CourseFormDialogInput,
  CourseFormDialogOutput,
  typeof CourseFormDialogComponent
> {
  readonly id = COURSE_FORM_DIALOG_ID;
  protected readonly component = CourseFormDialogComponent;

  protected override readonly options: DialogOptions = {
    cssClass: 'fullscreen',
    showBackdrop: false,
    handle: false,
  };

  override openDialog(config?: { input?: CourseFormDialogInput; options?: DialogOptions }) {
    const canQuit = config?.input?.canQuit ?? true;
    return super.openDialog({
      options: {
        ...this.options,
        backdropDismiss: canQuit,
        componentProps: {
          canQuit,
          canSelectExistingSubscriptions: config?.input?.canSelectExistingSubscriptions ?? false,
        },
      },
    });
  }
}
